"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantChatMessage = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const chat_helpers_1 = require("@/components/domains/chat/chat.helpers");
require("@/components/common");
let ParticipantChatMessage = class ParticipantChatMessage extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.avatarSrc = '';
        this.datetime = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-user-avatar
        size="32"
        name=${this.name}
        src=${(0, if_defined_js_1.ifDefined)(this.avatarSrc || undefined)}
      ></mm-user-avatar>
      <div class="body">
        ${this.renderMeta()}
        <div class="bubbles">
          <slot></slot>
        </div>
      </div>
    `;
    }
    renderMeta() {
        if (!this.name && !this.datetime)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <div class="meta">
        <mm-text class="name" size="12">${this.name}</mm-text>
        ${(0, chat_helpers_1.renderChatMessageTime)(this.datetime)}
      </div>
    `;
    }
};
ParticipantChatMessage.styles = (0, lit_1.css) `
    :host {
      display: flex;
      gap: var(--space-1) var(--space-2);
    }

    .body {
      display: flex;
      flex-direction: column;
      gap: var(--space-1);
    }

    .bubbles {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: var(--space-2);
    }

    .meta {
      display: flex;
      gap: var(--space-1);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ParticipantChatMessage.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-src' })
], ParticipantChatMessage.prototype, "avatarSrc", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ParticipantChatMessage.prototype, "datetime", void 0);
ParticipantChatMessage = __decorate([
    (0, decorators_js_1.customElement)('mm-participant-chat-message')
], ParticipantChatMessage);
exports.ParticipantChatMessage = ParticipantChatMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydGljaXBhbnQtY2hhdC1tZXNzYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicGFydGljaXBhbnQtY2hhdC1tZXNzYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFDM0QsZ0VBQXdEO0FBRXhELHlFQUE4RTtBQUU5RSwrQkFBNEI7QUFHckIsSUFBTSxzQkFBc0IsR0FBNUIsTUFBTSxzQkFBdUIsU0FBUSxnQkFBVTtJQUEvQzs7UUF5QnVCLFNBQUksR0FBRyxFQUFFLENBQUE7UUFDZ0IsY0FBUyxHQUFHLEVBQUUsQ0FBQTtRQUN2QyxhQUFRLEdBQUcsRUFBRSxDQUFBO0lBNEIzQyxDQUFDO0lBMUJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7ZUFHQSxJQUFJLENBQUMsSUFBSTtjQUNWLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsU0FBUyxJQUFJLFNBQVMsQ0FBQzs7O1VBRzFDLElBQUksQ0FBQyxVQUFVLEVBQUU7Ozs7O0tBS3RCLENBQUE7SUFDSCxDQUFDO0lBRU8sVUFBVTtRQUNoQixJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFaEQsT0FBTyxJQUFBLFVBQUksRUFBQTs7MENBRTJCLElBQUksQ0FBQyxJQUFJO1VBQ3pDLElBQUEsb0NBQXFCLEVBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQzs7S0FFekMsQ0FBQTtJQUNILENBQUM7O0FBckRNLDZCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBdUJsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztvREFBVTtBQUNnQjtJQUFwRCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxZQUFZLEVBQUUsQ0FBQzt5REFBZTtBQUN2QztJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7d0RBQWM7QUEzQjlCLHNCQUFzQjtJQURsQyxJQUFBLDZCQUFhLEVBQUMsNkJBQTZCLENBQUM7R0FDaEMsc0JBQXNCLENBdURsQztBQXZEWSx3REFBc0IifQ==